import {FC} from "react";

const PopisRaspolozivihDIjelova: FC<{ data: any[] }> = ({ data }) => {
    return null;
}
export default PopisRaspolozivihDIjelova;
